import _ from 'lodash'

import {
  LIST_USER_METADATA_STARTED,
  LIST_USER_METADATA_COMPLETED,
  LIST_USER_METADATA_FAILED,

  UPDATE_USER_METADATA_STARTED,
  UPDATE_USER_METADATA_COMPLETED,
  UPDATE_USER_METADATA_FAILED,

  CLEAR_ACTION_STATES
} from '@/store/types'

function getDefaultState () {
  return {
    loading: false,
    done: false,
    error: undefined,
    updateDone: false,
    updateError: undefined,

    userMetadata: '',
    appMetadata: ''
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    [LIST_USER_METADATA_STARTED] (state) {
      state.loading = true
    },
    [LIST_USER_METADATA_COMPLETED] (state, payload) {
      const { userMetadata, appMetadata } = payload
      state.done = true
      state.loading = false
      state.userMetadata = _.cloneDeep(userMetadata)
      state.appMetadata = _.cloneDeep(appMetadata)
    },
    [LIST_USER_METADATA_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },
    [UPDATE_USER_METADATA_STARTED] (state) {
      state.loading = true
      state.updateDone = false
      state.updateError = undefined
    },
    [UPDATE_USER_METADATA_COMPLETED] (state) {
      state.updateDone = true
      state.loading = false
    },
    [UPDATE_USER_METADATA_FAILED] (state, payload) {
      const { type, err } = payload
      state.loading = false
      state.updateError = err
      if (err instanceof SyntaxError) {
        state.updateError = `status.error.${type}_metadata`
      }
    },

    [CLEAR_ACTION_STATES] (state) {
      state.updateError = undefined
      state.updateDone = false
    }
  },

  actions: {
    async list ({ commit, rootState: { client = undefined } }, id) {
      try {
        commit(LIST_USER_METADATA_STARTED)
        const metadata = await client.managementClient.getMetadata(id)
        commit(LIST_USER_METADATA_COMPLETED, {
          userMetadata: metadata.userMetadata !== undefined ? metadata.userMetadata : '',
          appMetadata: metadata.appMetadata !== undefined ? metadata.appMetadata : ''
        })
      } catch (err) {
        commit(LIST_USER_METADATA_FAILED, err)
      }
    },
    async updateUserMetadata ({ commit, rootState: { client = undefined } }, payload) {
      const { id, userMetadata } = payload
      try {
        commit(UPDATE_USER_METADATA_STARTED)
        JSON.parse(userMetadata) // will throw when `userMetadata` is not a valid JSON object
        const metadata = await client.managementClient.updateMetadata(id, userMetadata, '')
        commit(UPDATE_USER_METADATA_COMPLETED)
        commit(LIST_USER_METADATA_COMPLETED, {
          userMetadata: metadata.userMetadata !== undefined ? metadata.userMetadata : '',
          appMetadata: metadata.appMetadata !== undefined ? metadata.appMetadata : ''
        })
      } catch (err) {
        commit(UPDATE_USER_METADATA_FAILED, {
          type: 'user',
          err: err
        })
      }
    },
    async updateAppMetadata ({ commit, rootState: { client = undefined } }, payload) {
      const { id, appMetadata } = payload
      try {
        commit(UPDATE_USER_METADATA_STARTED)
        JSON.parse(appMetadata) // will throw when `appMetadata` is not a valid JSON object
        const metadata = await client.managementClient.updateMetadata(id, '', appMetadata)
        commit(UPDATE_USER_METADATA_COMPLETED)
        commit(LIST_USER_METADATA_COMPLETED, {
          userMetadata: metadata.userMetadata !== undefined ? metadata.userMetadata : '',
          appMetadata: metadata.appMetadata !== undefined ? metadata.appMetadata : ''
        })
      } catch (err) {
        commit(UPDATE_USER_METADATA_FAILED, {
          type: 'app',
          err: err
        })
      }
    }
  }
}
